import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {IEditNameState} from "./types"

import {fetchEditEmail, fetchEditName, fetchEditPhone, fetchSendEmailCode} from "./asyncActions";

const initialState: IEditNameState = {
  name: "",
  email: "",
  phone: "",
  isLoading: false,
  code: ""
};

const editNameSlice = createSlice({
  name: "changeName",
  initialState,
  reducers: {
    editName(state, action: PayloadAction<string>) {
      state.name = action.payload;
    },
    editEmail(state, action: PayloadAction<string>) {
      state.email = action.payload;
    },
    editPhone(state, action: PayloadAction<string>) {
      state.phone = action.payload;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchEditName.pending, (state) => {
      state.isLoading = true
    });
    builder.addCase(fetchEditName.fulfilled, (state, action: PayloadAction<string>) => {
      state.name = action.payload;
      state.isLoading = false
    });
    builder.addCase(fetchEditEmail.pending, (state) => {
      state.isLoading = true
    });
    builder.addCase(fetchEditEmail.fulfilled, (state, action: PayloadAction<string>) => {
      state.email = action.payload;
      state.isLoading = false
    });
    builder.addCase(fetchSendEmailCode.pending, (state) => {
      state.isLoading = true
    });
    builder.addCase(fetchSendEmailCode.fulfilled, (state, action: PayloadAction<string>) => {
      state.code = action.payload;
      state.isLoading = false
    });
    builder.addCase(fetchEditPhone.pending, (state) => {
      state.isLoading = true
    });
    builder.addCase(fetchEditPhone.fulfilled, (state, action: PayloadAction<string>) => {
      state.phone = action.payload;
      state.isLoading = false
    });
  },
});

export const { editEmail,reset,editPhone,editName } = editNameSlice.actions;

export default editNameSlice.reducer;
